const Keys = {
  Pagarme_devKey: "ek_test_yCRumKDVQgqFkjlQojnTSHgWw7UI5g",
  // Pagarme_devKey: 'ek_live_tUTk0lWERRW26cMEYqZvCd6VsxYWJM',
  Pagarme_productionKey: "ek_live_tUTk0lWERRW26cMEYqZvCd6VsxYWJM"
};

export default Keys;
